export default __webpack_public_path__ + "static/char-v-02-ccfcee2946605978c1e873a17fdce768.mp4";